<template lang="pug">
 div
    FitmentModal(v-if="activeOverlay == 'fitment'")
    SaveCart(v-if="activeOverlay == 'sc'")
    OrderStatusLoginModal(v-if="activeOverlay == 'orderlogin'")
    LocationModal(v-if="$geolocation.enabled && activeOverlay == 'confirmLocationPopup'")
    CognitoModal(v-if="$cognito.enabled && activeOverlay == 'cognitoLoginPopup'")
</template>

<script>
const FitmentModal = () =>
    import(/* webpackChunkName: "fitment-modal" */ '@/components/fitment/fitmentModal')
const SaveCart = () => import(/* webpackChunkName: "save-cart" */ '@/components/cart/saveCart')
const OrderStatusLoginModal = () =>
    import(
        /* webpackChunkName: "order-status-login-modal" */ '@/pages/order/_components/statusLoginModal'
    )
const LocationModal = () =>
    import(/* webpackChunkName: "location-modal" */ '@/integrations/geolocation/locationModal')
const CognitoModal = () =>
    import(/* webpackChunkName: "cognito-modal" */ '@/integrations/cognito/cognitoModal')

export default {
    name: 'OverlaysInit',
    components: {
        FitmentModal,
        SaveCart,
        OrderStatusLoginModal,
        LocationModal,
        CognitoModal,
    },
    computed: {
        activeOverlay() {
            return this.$overlay.state.activeOverlay
        },
    },
    created() {
        this.$overlay.registerUrlKey('fitment')
        this.$overlay.registerUrlKey('sc')
        this.$overlay.registerUrlKey('orderlogin')
        if (this.$geolocation.enabled) this.$overlay.registerUrlKey('confirmLocationPopup')
        if (this.$cognito.enabled) this.$overlay.registerUrlKey('cognitoLoginPopup')

        // bugsnag: Errored where $route is undefined. Could not replicate.
        if (this.$route?.query?.mod) this.$overlay.show(this.$route.query.mod)
    },
}
</script>
